import { i18next } from '@bechtel/ht-clients-common';
import { AuthPermission } from '@bechtel/ht-types';
import { NavigationRoute } from '~/types/navigation-route';

export const navigationRoutes: NavigationRoute[] = [
  {
    path: '/reservations',
    name: i18next.t('Reservation Title'),
    icon: 'check-to-slot',
    permission: AuthPermission.RESERVATION_MODULE,
  },
  {
    path: '/mytools',
    name: i18next.t('My Tools Title'),
    icon: 'box-open-full',
    permission: AuthPermission.FAVORITES_MODULE,
  },

  {
    path: '/dispatch/home',
    name: i18next.t('Dispatch Title'),
    icon: 'check-to-slot',
    permission: AuthPermission.DISPATCH_MODULE,
  },
  {
    path: '/transfer',
    name: i18next.t('Tool Transfer Title'),
    icon: 'right-left',
    permission: AuthPermission.TOOL_TRANSFER_MODULE,
  },
  {
    path: '/returns',
    name: i18next.t('Returns Title'),
    icon: 'arrow-right-to-arc',
    permission: AuthPermission.RETURN_MODULE,
  },

  {
    path: '/map',
    name: i18next.t('Map Title'),
    icon: 'map-location-dot',
    permission: AuthPermission.MAP_MODULE,
  },
  {
    path: '/inventory',
    name: i18next.t('Inventory Title'),
    icon: 'warehouse-full',
    // TODO Once new icon received will replace it
    permission: AuthPermission.INVENTORY_MODULE,
  },
];
